import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

export const fetchSiteSettings = createAsyncThunk('siteSettings/fetch', async () => {
  const response = await $axios.get('/settings');
  return response.data?.data;
});

export const updateSiteSettings = createAsyncThunk('siteSettings/update', async (payload) => {
  const response = await $axios.patch('/settings', payload);
  return response.data?.data;
});

const siteSettingsSlice = createSlice({
  name: 'siteSettings',
  initialState: {
    data: null,
    loading: false,
    updating: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSiteSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchSiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to fetch settings';
      })
      .addCase(updateSiteSettings.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateSiteSettings.fulfilled, (state, action) => {
        state.updating = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(updateSiteSettings.rejected, (state, action) => {
        state.updating = false;
        state.error = action.error?.message || 'Failed to update settings';
      });
  },
});

export const { clearError } = siteSettingsSlice.actions;
export default siteSettingsSlice.reducer;
